module.exports = __webpack_public_path__ + "static/media/wallrus-welcome.d35d0b1c.png";